import { DatePipe } from "@angular/common";
import { CommissionEnum } from "@enums/commission";
import { CommissionType } from "@models/reports/reports";
import { Table } from "@models/table";
import { DetailViewerModalComponent } from "@pages/shared/reports/commissions-report/detail-viewer-modal/detail-viewer-modal.component";
import { formatNumberToLocal } from "src/app/utils/format-number-to-local";

const datePipe = new DatePipe('pt-BR');

export const FILTER_PAID_COMMISSIONS: CommissionType =   {
  id: CommissionEnum.PAID_COMMISSIONS,
  description: 'Comissões Pagas',
  startDateLabel: 'Data de pagamento inicial:',
  endDateLabel: 'Data de pagamento final:',
  filters: [
    {
      description: "Filtrar por: ",
      key: "filterBy",
      options: [
        { key: " ", value: "Sem filtro" }, 
        { key: "contract", value: "Contrato" }, 
        { key: "invoiceNumber", value: "Nota Fiscal" }, 
      ]
    }
  ],
  componentModal: DetailViewerModalComponent
}

export const REPORT_PAID_COMMISSIONS: Partial<Table<any>> = {
    headers: [
      { "key": "invoiceNumber", "value": "Nota Fiscal" },
      { "key": "paymentDate", "value": "Data de Pagamento" },
      // { "key": "periodType", "value": "Tipo de Período" },
      // { "key": "periodCode", "value": "Código do Período" },
      { "key": "period", "value": "Período" },
      { "key": "amountPaid", "value": "Valor Pago" },
    ],
    style: {
      table: {
        height: "500px",
      },
      data: [
        {
          key: "paymentDate",
          transform: (value) => datePipe.transform(value, "dd/MM/yyyy"),
        },
        {
          key: "amountPaid",
          transform: (value) => value ? `R$ ${ formatNumberToLocal(value) }` : "N/A"
        },
      ],
    },
    buttons: {read: true},
    messageWithoutDates: "Nenhum dado encontrado para 'Comissões Pagas'",
}

